import { AfterViewChecked, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { Virtualizer } from '@tanstack/virtual-core';

/**
 * Registra el elemento renderizado en el `Virtualizer` de TanStack para que
 * sea medido dinámicamente (vía ResizeObserver interno). El índice se lee del
 * atributo `data-index` presente en el mismo elemento.
 */
@Directive({ selector: '[ecoMeasure]' })
export class EcoMeasureDirective implements AfterViewChecked, OnDestroy {
  @Input('ecoMeasure') virtualizer: Virtualizer<HTMLElement, HTMLElement> | null = null;

  constructor(private el: ElementRef<HTMLElement>) { }

  ngAfterViewChecked(): void {
    // Es crítico reportar el elemento en cada ciclo de verificación de Angular.
    // TanStack internamente validará el atributo 'data-index' del nodo.
    if (this.virtualizer && this.el.nativeElement) {
      this.virtualizer.measureElement(this.el.nativeElement);
    }
  }

  ngOnDestroy(): void {
    // Pasamos el elemento actual en lugar de null si se va a destruir, o permitimos la limpieza nativa de TanStack si el nodo se desconecta.
    if (this.virtualizer && this.el.nativeElement) {
      this.virtualizer.measureElement(null);
    }
  }
}
